import { Header } from '@/ui/shared/atoms/Header';
import { Paragraph } from '@/ui/shared/atoms/Paragraph';
// import { Span } from '@/ui/shared/atoms/Span'; TODO: add span

export const Typography = {
  Header,
  Paragraph,
};
